export const ARTISTS_VIDEO_MIN_SIZE = 1;
export const ARTISTS_VIDEO_MAX_SIZE = 5000000;
